<template>
  <div>
    <base-title :title="StringLanguage.cashback"/>

    <base-box>
      <base-checkbox :label="'Ativar cashback'" v-model="cashback.enabled" :checked="cashback.enabled" class="mt_5 mb_5"/>

      <!-- <base-input
        :label="StringLanguage.minOrder"
        v-model.lazy="cashback.min_order"
        :moneyMask="StringLanguage.currencyConfigs"
        :masked="false"
        class="mt_20"
      /> -->

      <div v-if="cashback.enabled" class="mt_25">
        <base-input
            :label="StringLanguage.winOnePointToPayed"
            v-model.lazy="cashback.tax"
            :mask="'##%'"
            class="mb_20"
        />
        <base-input
            :label="StringLanguage.expireInNDays"
            v-model="cashback.expire_days"
            :mask="'####'"
            class="mb_20"
        />
        <base-message>O tempo mínimo para expiração dos valores adquiridos via cashback, é de 30 dias.</base-message>
      </div>
    </base-box>

    <div class="d-flex justify-end w-100">
      <base-button :text="StringLanguage.save" @click="isCashbackValid() && save()" :disabled="loadingData" />
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import DeliveryTime from "@/plugins/core/schema/configurations/DeliveryTime/DeliveryTime";
import StoreAPI from "@/api/store";
import Vue from "vue";

import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseBox from "@/components/Box";
import BaseInput from "@/components/Input";
import BaseLabel from "@/components/Label";
import BaseCheckbox from "@/components/Checkbox";
import BaseMessage from "@/components/Message";

export default {
  data() {
    return {
      loadingData: false,
      cashback: {
        enabled: false,
        min_order: null,
        tax: null,
        expire_days: 30
      },
      originalData: {
        enabled: false,
        min_order: null,
        tax: null,
        expire_days: 30
      }
    };
  },
  created() {
    let self = this;
    this.loadingData = true;
    StoreAPI.storeGetConfiguration("cashback")
      .then(response => {
        self.set(response);
      })
      .catch(err => {
        console.log(err);
        alert(StringLanguage.loadError);
      })
      .finally(() => {
        this.loadingData = false;
      });
  },
  beforeRouteLeave (to, from, next) {

    if(JSON.stringify(this.originalData) != JSON.stringify(this.cashback)) {
      if(this.isCashbackValid()){
        this.save().then(() => {
          next();
        });
      }
    }else{
      next();
    }
  },
  methods: {
    set(response) {
      if (response.getErrors([]).length > 0) {
        return false;
      } else if (response.getData({}).cashback || false) {
        let cashback = response.getData({
          cashback: {
            enabled: false,
            min_order: null,
            tax: null,
            expire_days: 30
          }
        }).cashback;
        Vue.set(this, "cashback", {
          enabled: cashback.enabled,
          min_order: cashback.min_order,
          tax: (1 / (cashback.tax || 1)) * 100,
          expire_days: cashback.expire_days
        });
        Vue.set(this, "originalData", {
          enabled: cashback.enabled,
          min_order: cashback.min_order,
          tax: String((1 / (cashback.tax || 1)) * 100)  ,
          expire_days: cashback.expire_days
        });
      } else {
        Vue.set(this, "cashback", {
            enabled: false,
            min_order: null,
            tax: null,
            expire_days: 1
        });
        Vue.set(this, "originalData", {
            enabled: false,
            min_order: null,
            tax: null,
            expire_days: 1
        });
      }
    },
    save() {
      let self = this;

      return StoreAPI.storeConfiguration({
        cashback: {
          ...this.cashback,
          tax: 1 / (this.cashback.tax / 100)
        }
      })
        .then(response => {
          self.set(response);
          this.$store.dispatch('store/getConfigurations')
        })
        .catch(err => {
          console.log(err);
          alert(StringLanguage.saveError);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    isCashbackValid(){
       if(this.cashback.tax == ''){
        alert(StringLanguage.errorEmptyCashbackPercentage);
        return false;
      }

      if (+this.cashback.expire_days < 30) {
        alert(StringLanguage.errorMinCashbackDaysExpiration)
        return false;
      }

      return true;
    }
  },
  components: {
    TheMask,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseLabel,
    BaseCheckbox,
    BaseMessage,
  }
};
</script>
<style scoped>
</style>
